import moment from "moment";

/** Collapsed pickup group header: `MM/DD · start–end` (same time text as row `timeRange`). */
export function formatCollapsedPickupWindow(dateIso: string, timeRangeLabel: string): string {
  const m = moment(dateIso);
  const datePart = m.isValid() ? m.format("MM/DD") : "—";
  const times = timeRangeLabel?.trim() ? timeRangeLabel.trim() : "";
  if (!times || times === "—") return datePart;
  return `${datePart} · ${times}`;
}
